import * as React from 'react';

import {CellAsync} from '../../../../../../ui/entity-list/columns/cell/async/async';

import {RenderedValue} from './rendered-value';

type Props = {
    schemaField: any;
    value: string | number | any[] | null;
    isAsync?: boolean;
    asyncFieldName?: string;
    entityId?: string;
};

export function LeadCardRow(props: Props) {
    // Handle async fields - they fetch their own data
    if (props.isAsync && props.asyncFieldName && props.entityId) {
        return <CellAsync name={props.asyncFieldName} entityId={props.entityId} />;
    }

    // For non-async fields, value should never be null
    if (props.value == null) {
        return null;
    }

    return <RenderedValue value={props.value} schemaField={props.schemaField} isLeadCard={true} />;
}
